import { createSlice } from '@reduxjs/toolkit';

import { loginTwitchUser, userLogin, validateToken } from './auth.actions';

const initialState = {
  user: {},
  isLoadingLogin: true,
  validationData: {
    message: '',
    status: '',
    token: ''
  },
  isLoadingTokenValidation: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearAuthState: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(loginTwitchUser.pending, (state) => {
      state.isLoadingLogin = true;
    });
    builder.addCase(loginTwitchUser.fulfilled, (state, action) => {
      state.user = action.payload;
      state.isLoadingLogin = false;
    });
    builder.addCase(loginTwitchUser.rejected, (state) => {
      state.isLoadingLogin = true;
    });

    builder.addCase(userLogin.pending, (state) => {
      state.isLoadingLogin = true;
    });
    builder.addCase(userLogin.fulfilled, (state, action) => {
      state.user = action.payload;
      state.isLoadingLogin = false;
    });
    builder.addCase(userLogin.rejected, (state) => {
      state.isLoadingLogin = false;
    });

    builder.addCase(validateToken.pending, (state) => {
      state.isLoadingTokenValidation = true;
    });
    builder.addCase(validateToken.fulfilled, (state, action) => {
      state.user = action.payload?.user;
      state.validationData = action.payload;
      state.isLoadingTokenValidation = false;
    });
    builder.addCase(validateToken.rejected, (state) => {
      state.isLoadingTokenValidation = false;
    });
  }
});

export const { clearAuthState } = authSlice.actions;

export default authSlice.reducer;
